/* Routes for sidebar menu
  For a single entry: {
    name: Entry Display Name,
    icon: Entry Icon,
    ID: dashboardRoutes.[route name].ID,
    path: dashboardRoutes.[route name].path,
  }

  For a folder: {
    name: Folder Display Name,
    icon: Folder Icon,
    ID: random ID for key for component in the loop,
    children: [{
      name: Sub entry name,
      path: dashboardRoutes.[route name].path,
    }],
  }
*/
import { HiTemplate } from "react-icons/hi";
import { IoSettings } from "react-icons/io5";
import { FaUserGroup } from "react-icons/fa6";
import { FaCoins } from "react-icons/fa6";
import { FaHandshakeSimple } from "react-icons/fa6";
import { BiSolidUserAccount } from "react-icons/bi";
import {
  MdOutlineBrandingWatermark,
  MdBrandingWatermark,
  MdCampaign,
  MdGroups,
  MdPerson,
} from "react-icons/md";

import dashboardLayoutRoutes from "../../../router/router components/dashboardLayoutRoutes";

const routes = [
  {
    name: "Profile",
    icon: MdPerson,
    ID: dashboardLayoutRoutes.profileDetailsRoute.ID,
    path: dashboardLayoutRoutes.profileDetailsRoute.path,
  },

  {
    name: "Audience",
    icon: MdGroups,
    ID: dashboardLayoutRoutes.audienceListRoute.ID,
    path: dashboardLayoutRoutes.audienceListRoute.path,
  },

  {
    name: "Brands",
    icon: MdBrandingWatermark,
    ID: dashboardLayoutRoutes.brandsAgencyList.ID,
    path: dashboardLayoutRoutes.brandsAgencyList.path,
  },

  {
    name: "Templates",
    icon: HiTemplate,
    ID: dashboardLayoutRoutes.templateListRoute.ID,
    path: dashboardLayoutRoutes.templateListRoute.path,
  },

  {
    name: "Credits",
    icon: FaCoins,
    ID: dashboardLayoutRoutes.creditRoute.ID,
    path: dashboardLayoutRoutes.creditRoute.path,
  },

  {
    name: "Accounts",
    icon: BiSolidUserAccount,
    ID: dashboardLayoutRoutes.accountVerificationRoute.ID,
    path: dashboardLayoutRoutes.accountVerificationRoute.path,
  },

  {
    name: "Platforms",
    icon: BiSolidUserAccount,
    ID: dashboardLayoutRoutes.platformsTenantsRoute.ID,
    path: dashboardLayoutRoutes.platformsTenantsRoute.path,
  },

  {
    name: "Campaign Request",
    icon: MdCampaign,
    ID: dashboardLayoutRoutes.adminCampaignRequestRoute.ID,
    path: dashboardLayoutRoutes.adminCampaignRequestRoute.path,
  },

  {
    name: "Verification",
    icon: MdOutlineBrandingWatermark,
    ID: dashboardLayoutRoutes.unverifiedBrandRoute.ID,
    children: [
      {
        name: "Brands",
        ID: dashboardLayoutRoutes.unverifiedBrandRoute.ID,
        path: dashboardLayoutRoutes.unverifiedBrandRoute.path,
      },
      {
        name: "Agencies",
        ID: dashboardLayoutRoutes.unverifiedAgenciesRoute.ID,
        path: dashboardLayoutRoutes.unverifiedAgenciesRoute.path,
      },
    ],
  },

  {
    name: "Campaigns",
    icon: MdCampaign,
    ID: dashboardLayoutRoutes.superadminAllCampaignsRoute.ID,
    path: dashboardLayoutRoutes.superadminAllCampaignsRoute.path,
  },

  {
    name: "Campaigns",
    icon: MdCampaign,
    ID: dashboardLayoutRoutes.myCampaignRoute.ID,
    path: dashboardLayoutRoutes.myCampaignRoute.path,
  },

  {
    name: "Campaigns",
    icon: MdCampaign,
    ID: dashboardLayoutRoutes.campaignRequestRoute.ID,
    path: dashboardLayoutRoutes.campaignRequestRoute.path,
  },

  {
    name: "Users",
    icon: FaUserGroup,
    ID: dashboardLayoutRoutes.brandListRoute.ID,
    path: dashboardLayoutRoutes.brandListRoute.path,
  },

  {
    name: "On-Boarding",
    icon: FaHandshakeSimple,
    ID: dashboardLayoutRoutes.superadminDPOnBoardingListRoute.ID,
    path: dashboardLayoutRoutes.superadminDPOnBoardingListRoute.path,
  },

  // {
  //   name: "Channel Settings",
  //   icon: MdSettingsInputComponent,
  //   ID: dashboardLayoutRoutes.channelAgentSettingRoute.ID,
  //   path: dashboardLayoutRoutes.channelAgentSettingRoute.path,
  // },

  // {
  //   name: "Lead Qualification",
  //   icon: MdPersonSearch,
  //   ID: dashboardLayoutRoutes.leadCampaignListPage.ID,
  //   path: dashboardLayoutRoutes.leadCampaignListPage.path,
  // },

  {
    name: "Settings",
    icon: IoSettings,
    ID: dashboardLayoutRoutes.superadminPermissionSettingsRoute.ID,
    children: [
      {
        ID: dashboardLayoutRoutes.superadminDynamicUISettingList.ID,
        name: "Site Settings",
        path: dashboardLayoutRoutes.superadminDynamicUISettingList.path,
      },

      {
        name: "Groups",
        ID: dashboardLayoutRoutes.groupListRoute.ID,
        path: dashboardLayoutRoutes.groupListRoute.path,
      },

      {
        name: "Manage Dynamic Fields",
        ID: dashboardLayoutRoutes.customFieldsListRoute.ID,
        path: dashboardLayoutRoutes.customFieldsListRoute.path,
      },
    ],
  },
];

export default routes;
